import React from "react";

const ImportProgressbar = ({ total = 0, processed = 0 }) => {
  const progress = total ? Math.min((processed / total) * 100, 100) : 0;
  const roundProgress = Math.round(progress);

  return (
    <div className="progress-container">
      <div className="progress-bar" style={{ width: `${progress}%` }}>
        <span className="progress-text">{roundProgress}%</span>
        <span
          className="progress-after"
          style={{
            position: "absolute",
            right: "-6px",
            width: "12px",
            height: "100%",
            background: "#3b82f6",
            clipPath: "path('M 0 0 L 6 0 A 3 3 0 0 1 6 12 L 0 12 z')",
            opacity: progress > 15 ? 1 : 0,
            transition: "opacity 0.3s ease-in-out"
          }}
        />
      </div>
    </div>
  );
};

export default ImportProgressbar;
